export const SET_SELECTED_PRODUCT = 'SUBSCRIPTION_PRODUCT_FAMILY/SET_SELECTED_PRODUCT';
export const RESET_SELECTED_PRODUCT = 'SUBSCRIPTION_PRODUCT_FAMILY/RESET_SELECTED_PRODUCT';
